import { ModuleName, ModuleNamePerceptionBar, ModuleNameScreenReader } from '../enums/enums'

export function parseModuleName (name: string | null): ModuleName | null {
  if (name === null) {
    return null
  }

  switch (name.toLowerCase()) {
    case ModuleName.Cocaine.toLowerCase():
      return ModuleName.Cocaine
    case ModuleName.Xanax.toLowerCase():
      return ModuleName.Xanax
    case ModuleName.Mdma.toLowerCase():
      return ModuleName.Mdma
    case ModuleName.Response.toLowerCase():
      return ModuleName.Response
    case ModuleName.Lightning.toLowerCase():
      return ModuleName.Lightning
    default:
      return null
  }
}

export function getModuleNamePerceptionBar (name: ModuleName | null): ModuleNamePerceptionBar | null {
  if (name === null) {
    return null
  }

  switch (name) {
    case ModuleName.Cocaine:
      return ModuleNamePerceptionBar.Cocaine
    case ModuleName.Xanax:
      return ModuleNamePerceptionBar.Xanax
    case ModuleName.Mdma:
      return ModuleNamePerceptionBar.Mdma
    case ModuleName.Response:
      return ModuleNamePerceptionBar.Response
    case ModuleName.Lightning:
      return ModuleNamePerceptionBar.Lightning
  }
}

export function getModuleNameScreenReader (name: ModuleName | null): ModuleNameScreenReader | null {
  if (name === null) {
    return null
  }

  switch (name) {
    case ModuleName.Cocaine:
      return ModuleNameScreenReader.Cocaine
    case ModuleName.Xanax:
      return ModuleNameScreenReader.Xanax
    case ModuleName.Mdma:
      return ModuleNameScreenReader.Mdma
    case ModuleName.Response:
      return ModuleNameScreenReader.Response
    case ModuleName.Lightning:
      return ModuleNameScreenReader.Lightning
  }
}

const moduleLevels: Map<ModuleName, number> = new Map([
  [ModuleName.Cocaine, 1],
  [ModuleName.Xanax, 2],
  [ModuleName.Mdma, 3],
  [ModuleName.Response, 4],
  [ModuleName.Lightning, 5]
])

export function getModuleLevel (moduleName: ModuleName | null): number {
  const defaultLevel = 1
  if (moduleName === null) {
    return defaultLevel
  }
  const level = moduleLevels.get(moduleName)

  if (level === undefined) {
    return defaultLevel
  }

  return level
}
